module.exports = __webpack_public_path__ + "static/img/Spinner-1s-200px.26c4ffe.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Spinner-1s-200px.gif
// module id = iG1o
// module chunks = 0